export const styles = () => ({
  root: {},
  title: {
    borderBottom: "2px solid rgba(0, 0, 0, 0.20)",
    fontSize: 15,
  },
});
